/* import __COLOCATED_TEMPLATE__ from './projected-conversations-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    ranking: string;
  };
}

export default class ProjectedConversationsStamp extends Component<Signature> {
  @service declare intl: IntlService;

  get rankingStyling() {
    switch (this.args.ranking) {
      case ProjectedConversationsRanking.High as unknown as string:
        return 'bg-vis-mantis-40 text-on-success';
      case ProjectedConversationsRanking.Medium as unknown as string:
        return 'bg-vis-mantis-70 text-default';
      case ProjectedConversationsRanking.Low as unknown as string:
        return 'bg-vis-mantis-80 text-default';
      default:
        return 'bg-vis-mantis-80 text-default';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::ProjectedConversationsStamp': typeof ProjectedConversationsStamp;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/projected-conversations-stamp': typeof ProjectedConversationsStamp;
  }
}
